<template>
  <el-dialog title="授权证书" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" ref="form">
      <el-form-item label="昵称" prop="nick_name" :label-width="formLabelWidth">
        <el-input v-model="form.nick_name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone" :label-width="formLabelWidth">
        <el-input v-model.number="form.phone" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
          <el-radio v-model="form.status" label="0">待审核</el-radio>
          <el-radio v-model="form.status" label="1">审核通过</el-radio>
          <el-radio v-model="form.status" label="2">审核不通过</el-radio>
      </el-form-item>

      <el-form-item label="证书图" prop="image_id" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">上传图片</el-button>
          <div v-if="form.image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="saveCert" :loading="loading">确 定</el-button>
    </div>
     <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>
</template>

<script>

  import PlusApi from '@/api/plus.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        form: {
          nick_name: '',
          phone: '',
          image_id:'',
          status:'',
          certificate_id:'',
        },
        // formRules: {
        //   nick_name: [{
        //     required: true,
        //     message: '请输入昵称',
        //     trigger: 'blur'
        //   }]
        //   // phone: [{
        //   //   type: 'number',
        //   //   message: '请输入正确手机号码'
        //   // }]
        // },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        radio:'',//审核状态
        /*是否上传图片*/
        isupload: false,
        file_path:'',
       
      };
    },
    props: ['open_edit', 'editform'],
    created() {
      this.dialogVisible = this.open_edit;
      // console.log(this.editform);
      this.form.certificate_id = this.editform.model.certificate_id;
      this.form.nick_name = this.editform.model.nick_name;
      this.form.image_id = this.editform.model.img_id;
      this.form.phone = this.editform.model.phone;
      this.file_path = this.editform.model.img_url;
      this.form.status = this.editform.model.status.toString();
    },
    methods: {
      /*编辑证书*/
      saveCert() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            PlusApi.editCertificate(params,true).then(data => {
              self.loading = false;
              self.$message({
                message: '修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

    }
  };
</script>

<style>
  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/certificate/certificate/dialog/Edit.vue